import { render, staticRenderFns } from "./default.vue?vue&type=template&id=611013c6&scoped=true&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=611013c6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611013c6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/var/www/app/components/Header.vue').default,Footer: require('/var/www/app/components/Footer.vue').default,CookiePopup: require('/var/www/app/components/CookiePopup.vue').default})
